import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import HomePageBG from './assets/HomepageBG.jpg';
import { Footer } from './components/Footer';
import { Navbar } from './components/Navbar';
import { ProtectedRoute } from './components/ProtectedRoute';
import { PublicRoute } from './components/PublicRoute';
import { ROUTES } from './constants/routes';
import { EquipmentListPage } from './pages/admin/EquipmentListPage';
import { ReservationList } from './pages/admin/ReservationList';
import { UserList } from './pages/admin/UserList';
import { Login } from './pages/auth/Login';
import { Signup } from './pages/auth/Signup';
import { DetailEquipmentPage } from './pages/farmshare/DetailEquipmentPage';
import { FarmsharePage } from './pages/farmshare/FarmsharePage';
import { FarmsharePage as FarmsharePageInProgress } from './pages/farmshare/FarmsharePageInProgress';
import { UserReservations } from './pages/farmshare/UserReservations';
import { AboutUsPage } from './pages/public/AboutUsPage';
import { AchievementsPage } from './pages/public/AchievementsPage';
import { ContactUsPage } from './pages/public/ContactUsPage';
import { ErrorPage } from './pages/public/ErrorPage';
import { EventPage } from './pages/public/EventPage';
import { HomePage } from './pages/public/HomePage';
import { PrivacyPage } from './pages/public/PrivacyPage';
import { RCDPage } from './pages/public/RCDPage';
import { ResourcesPage } from './pages/public/ResourcesPage';
import { UserProfilePage } from './pages/user/UserProfilePage';
import { checkAuthStatus } from './redux/slices/authSlice';
import store from './redux/store';
import { setStoreReference } from './api';

// language switcher moved into Navbar

setStoreReference(store);

const App = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(checkAuthStatus());
  }, [dispatch]);

  return (
    <BrowserRouter>
      <Routes>
        <Route path={ROUTES.HOME} element={<HomePage />} />
        <Route
          path={ROUTES.LOGIN}
          element={
            // Dont go here if logged in.
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path={ROUTES.SIGNUP}
          element={
            // Dont go here if logged in.
            <PublicRoute>
              <Signup />
            </PublicRoute>
          }
        />
        <Route path={ROUTES.EVENTS} element={<EventPage />} />
        {/*         <Route
          path="/farmshare"
          element={
            <ProtectedRoute>
              <FarmsharePage />
            </ProtectedRoute>
          }
        /> */}
        <Route path={ROUTES.TEMP_FARM_SHARE} element={<FarmsharePage />} />
        <Route
          path={ROUTES.DETAIL_EQUIPMENT}
          element={
            <ProtectedRoute>
              <DetailEquipmentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.PROFILE}
          element={
            <ProtectedRoute>
              <UserProfilePage />
            </ProtectedRoute>
          }
        />
        <Route path={ROUTES.FARM_SHARE} element={<FarmsharePageInProgress />} />
        <Route path={ROUTES.ACHIEVEMENTS} element={<AchievementsPage />} />
        <Route path={ROUTES.ABOUT_US} element={<AboutUsPage />} />
        <Route path={ROUTES.CONTACT} element={<ContactUsPage />} />
        <Route path={ROUTES.RCD} element={<RCDPage />} />
        <Route path={ROUTES.RESOURCES} element={<ResourcesPage />} />
        <Route path={ROUTES.PRIVACY} element={<PrivacyPage />} />
        <Route
          path={ROUTES.USER_LIST}
          element={
            <ProtectedRoute requireAdmin={true}>
              <UserList />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.RESERVATION_LIST}
          element={
            <ProtectedRoute requireAdmin={true}>
              <ReservationList />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.MY_RESERVATIONS}
          element={
            <ProtectedRoute>
              <UserReservations />
            </ProtectedRoute>
          }
        />
        <Route
          path={ROUTES.EQUIPMENT_LIST}
          element={
            <ProtectedRoute requireAdmin={true}>
              <EquipmentListPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="*"
          element={
            <>
              <Navbar src={HomePageBG} pageName={``} />
              <ErrorPage />
            </>
          }
        />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
